export const DUPLICATE_STORY_COPY = {
  done: (name: string) => `Created "${name}"`,
  open: "Open",
  failed: "Couldn't duplicate the story.",
  retry: "Try again.",
  menu: "Duplicate",
} as const;
